/**
* @name: index
* @author: weiyong
* @date: 2022-10-26 22:14
* @description：index
* @update: 2022-10-26 22:14
*/
<template>
  <div class="seeSimpleFlowImg wh100b"
       :style="['--backgroundColor:'+(props.ctlBgColor)+'',elCtlStyle]">
    <div class="page-list-record wh100b">
      <a-skeleton avatar v-if="loadingFlag" :paragraph="paragraph"/>
      <iframe id="simpleFlowDesCtl" allowfullscreen="true"
              @load="loadPage" class="wh100b" :src="iframeUrl" style="border: 0"></iframe>
      <div v-if="!isPreview&&!props.closeMask" class="xmPageContent-mask"></div>
    </div>
  </div>

</template>

<script lang="ts">
import {defineComponent} from 'vue';
import { useI18n } from "vue-i18n";

export default defineComponent({
  components: {
  },
  name: "seeSimpleFlowImgCtl",
});
</script>

<script lang="ts" setup>
import {Skeleton as ASkeleton,Button as AButton} from 'ant-design-vue';
import { StorageUtils} from "xmgoing-utils";
import {openUrl} from "xmgoing-utils";
import SysConfigUtils from "@/utils/sysConfigUtils";
import {useCtlStyle} from "@/main-page/hooks/useCtlStyle";
import {useVuexState} from "@/main-page/ctls/hooks/useVuexState";
import GoingUtils from "@/utils/goingUtils";
import {unref} from "vue";
import {usePageModelsStore} from "@/store/modules/pageModels";
import {storeToRefs} from "pinia";

const {t} = useI18n()


interface propTypes {
  queryParams:any;
  logCtlProps:any;
  selBackNode:boolean;
  winParams:any;
  props: any,
  events: any,
  styles: any,
  showLabel: boolean,
  model: any,
}

const propsPage = withDefaults(defineProps<propTypes>(), {
  queryParams:{},
  selBackNode:false,
  winParams:{},
  logCtlProps:{},
  showLabel: true,
  styles: {},
  events: [],
  props: {},
  model: {},
});
const {props, styles, model, events, winParams,logCtlProps,selBackNode,queryParams}: any = propsPage;

unref(props).isFormEl=false;

const {vuex,stateProps} = useVuexState({sectionConfig:props,vuexProps:['showCtl','disabled','showLoading']});
const {elCtlStyle,elBaseStyle} = useCtlStyle({styles,props,propsStyl:['width','height']});


const pageModelsStore = usePageModelsStore();
const {state} = storeToRefs(pageModelsStore);
const paragraph = computed(() => {
  return {rows: 44}
})
const loadingFlag: any = ref(true);
const iframeUrl: any = ref(null);
const initFirameUrl=function (){
  const params = {
    recordForm:unref(logCtlProps).recordFrom||'busRecord',
    recordId:unref(queryParams).id,
    pageCode:unref(props).pageCode,
    projectI18n: StorageUtils.getItem('projectI18n') || 'zh-CN',
    menuId: StorageUtils.getSessionItem("menuId"),
    appId: StorageUtils.getSessionItem('appId'),
    selBackNode:unref(selBackNode),
    sessionId: StorageUtils.getSessionItem('sessionId'),
  }
  let url=SysConfigUtils.autoFlowUrl+ "/showSimpleFlowImg";
  url=url.replaceAll("//showSimpleFlowImg","/showSimpleFlowImg");
  iframeUrl.value = openUrl(url, params);
}
onMounted(() => {
  if(unref(props).pageCode){
    initFirameUrl();
  }else{
    initFirameUrl();
  }
})

watch(()=>selBackNode,(newVal)=>{
  initFirameUrl();
})
watch(()=>unref(props).pageCode,(newVal)=>{
  if(unref(props).pageCode){
    initFirameUrl();
  }
})
const emits = defineEmits(['closeLoading'])
const loadPage = () => {
  emits('closeLoading', {})
  nextTick(() => {
    loadingFlag.value = false;
  })
}

//是否可以拖拽
const isPreview = computed(() => {
  if (GoingUtils.getIsPreview()) {
    return true;
  }
  return false;
})

onMounted(()=>{
  const xmPanel:any= document.querySelector("#simpleFlowDesCtl").closest(".xmPanel");
  if(xmPanel){
    xmPanel.style.height='calc(100% - 2px)';
  }
})


</script>

<style type="text/css" lang="less" scoped>
.seeSimpleFlowImg{
  .xmPageContent-mask{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.10);
  }
}

</style>
